// anyMatchRoute 匹配任何内容路由
import NotFound from '@/views/common/404.vue';
import PermError from '@/views/common/perm-error.vue';
import RolePermError from '@/views/common/role-perm-error.vue';

export const anyMatchRoute = (redirect = '/404') => {
    return {
        name: 'anyPath',
        path: '/:pathMatch(.*)*',
        redirect: '/404',
    };
};

// notFoundRoute 页面找不到路由
export const notFoundRoute = () => ({
    name: 'notFound',
    path: '/404',
    component: NotFound,
    meta: {
        title: '404',
    },
});

// 操人权限不足路由
export const permErrorRoute = () => ({
    name: 'permError',
    path: '/perm-error',
    component: PermError,
    meta: {
        title: '403',
    },
});

// 角色权限不足路由
export const rolePermErrorRoute = () => ({
    name: 'rolePermError',
    path: '/role-perm-error',
    component: RolePermError,
    meta: {
        title: '403',
    },
});

